import type {
  CreateWebhookSubscriptionMutationInput as GQLInput,
  UpdateWebhookSubscriptionMutationInput as GQLUpdateInput,
} from '../../../generated/api.graphql';
import { take } from '../../../util';

export type WebhookSubscriptionInput = {
  destinationUrl: string;
  topics: string[];
  includeHolds: boolean;
};

export const toGqlInput = (input: WebhookSubscriptionInput): GQLInput =>
  take<GQLInput, WebhookSubscriptionInput>(input, 'destinationUrl', 'topics', 'includeHolds');

export const toGqlUpdateInput = (id: number, input: WebhookSubscriptionInput): GQLUpdateInput => ({
  ...take<GQLUpdateInput, WebhookSubscriptionInput>(input, 'destinationUrl', 'topics', 'includeHolds'),
  id: String(id),
});
